import styled from "styled-components";
import { theme } from "../theme/lexusTheme";

const Label = styled.label.attrs(() => ({
    className: "body-text",
}))`
    display: block;
    width: 100%;
    color: ${theme.colors.platinumDark};
`;

export default Label;
